import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SocketProvider } from "./context/SocketContext";
import Layout from "./components/Layout";
import Login from "./auth/Login";
import Signup from "./auth/Signup";
import VerifyEmail from './auth/VerifyEmail';
import ForgetPassword from "./auth/ForgetPassword";
import ResetPassword from "./auth/ResetPassword";
import Invoice from "./pages/Account-Setting/Invoice/Invoice";
import Documents from "./pages/Documents/Documents";
import Help from "./pages/HelpGuide/Help";
import Profile from "./pages/Account-Setting/Profile/Profile";
import USACompanyFormation from "./pages/USA-Company-Formation/USACompanyFormation"
import CFO from "./pages/CFO-Advisory/CFO";
import Registered from "./pages/Registered-Agent/RegisteredAgentPage";
import RegisteredAgentPreview from "./pages/Registered-Agent/RegisteredAgentPreview";
import Bookkeeping from "./pages/Bookkeeping/Bookkeeping";
import TaxFiling from "./pages/Tax Filling/TaxFiling";
import AnnualReportService from "./pages/AnnualReportService/AnnualReportService";
import PrivateRoute from "./components/PrivateRoute";
import Pricing from "./pages/Pricing/Pricing";
import PaymentSuccess from './pages/Pricing/PaymentSuccess';
import PaymentHistory from './pages/Pricing/PaymentHistory';

function App() {
  return (
    <SocketProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="/" element={<Layout />}>
            <Route path="/help" element={<PrivateRoute> <Help /> </PrivateRoute>} />
            <Route path="/invoice" element={<PrivateRoute> <Invoice /> </PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute> <Profile /> </PrivateRoute>} />
            <Route path="/documents" element={<PrivateRoute> <Documents /> </PrivateRoute>} />
            <Route path="/pricing" element={<PrivateRoute> <Pricing /> </PrivateRoute>} />
            <Route path="/payment-success" element={<PrivateRoute> <PaymentSuccess /> </PrivateRoute>} />
            <Route path="/payment-history" element={<PrivateRoute> <PaymentHistory /> </PrivateRoute>} />
            <Route path="/usa" element={<PrivateRoute> <USACompanyFormation /> </PrivateRoute>} />
            <Route path="/cfo" element={<PrivateRoute> <CFO /> </PrivateRoute>} />
            <Route path="/registered-agent" element={<PrivateRoute> <Registered /> </PrivateRoute>} />
            <Route path="/registered-agent/preview/:documentId" element={<PrivateRoute> <RegisteredAgentPreview /> </PrivateRoute>} />
            <Route path="/bookkeeping" element={<PrivateRoute> <Bookkeeping /> </PrivateRoute>} />
            <Route path="/tax-filing" element={<PrivateRoute> <TaxFiling /> </PrivateRoute>} />
            <Route path="/annual-report" element={<PrivateRoute> <AnnualReportService /> </PrivateRoute>} />

          </Route>

        </Routes>
      </Router>
    </SocketProvider>
  ); 
}

export default App;